import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, PhotoModel } from '@common/models';

export interface ISalesItemListingModel extends IModel {
  salesItemId: number;
  salesSubCategoryId: number;
  salesItemTypeId: number;
  discountTypeId: number;
  speciesId: number;
  name: string;
  fullName: string;
  description: string;
  helpPhotoId: number;
  isAutomaticallyGiven: boolean;
  salesSubCategoryName: string;
  salesItemTypeName: string;
  discountTypeName: string;
  speciesName: string;
  helpPhoto: PhotoModel;
  currentPrice: number;
  hasAttributes: number;
  hasRequirements: number;
  hasSatisfiers: number;
  hasMarkets: number;
  hasTraits: number;
  businessLineId: number;
}

export class SalesItemListingModel
  extends Model
  implements ModelRecord<ISalesItemListingModel>
{
  salesItemId: number;
  salesSubCategoryId: number;
  salesItemTypeId: number;
  discountTypeId: number;
  speciesId: number;
  name: string;
  fullName: string;
  description: string;
  helpPhotoId: number;
  isAutomaticallyGiven: boolean;
  salesSubCategoryName: string;
  salesItemTypeName: string;
  discountTypeName: string;
  speciesName: string;
  helpPhoto: PhotoModel;
  currentPrice: number;
  hasAttributes: number;
  hasRequirements: number;
  hasSatisfiers: number;
  hasMarkets: number;
  hasTraits: number;
  businessLineId: number;

  constructor(params?: Partial<ISalesItemListingModel>) {
    super(params);
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.salesSubCategoryId = defaultTo(params?.salesSubCategoryId, 0);
    this.salesItemTypeId = defaultTo(params?.salesItemTypeId, 0);
    this.discountTypeId = defaultTo(params?.discountTypeId, 0);
    this.speciesId = defaultTo(params?.speciesId, 0);
    this.name = defaultTo(params?.name, '');
    this.fullName = defaultTo(params?.fullName, '');
    this.description = defaultTo(params?.description, '');
    this.helpPhotoId = defaultTo(params?.helpPhotoId, 0);
    this.isAutomaticallyGiven = defaultTo(params?.isAutomaticallyGiven, false);
    this.salesSubCategoryName = defaultTo(params?.salesSubCategoryName, '');
    this.salesItemTypeName = defaultTo(params?.salesItemTypeName, '');
    this.discountTypeName = defaultTo(params?.discountTypeName, '');
    this.speciesName = defaultTo(params?.speciesName, '');
    this.helpPhoto = params?.helpPhoto
      ? new PhotoModel(params.helpPhoto)
      : new PhotoModel();
    this.currentPrice = defaultTo(params?.currentPrice, 0);
    this.hasAttributes = defaultTo(params?.hasAttributes, 0);
    this.hasRequirements = defaultTo(params?.hasRequirements, 0);
    this.hasSatisfiers = defaultTo(params?.hasSatisfiers, 0);
    this.hasMarkets = defaultTo(params?.hasMarkets, 0);
    this.hasTraits = defaultTo(params?.hasTraits, 0);
    this.businessLineId = defaultTo(params?.businessLineId, 0);
  }
}
